import { Component, Inject, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MerchantBankHttpService } from '@core/services/merchant-bank-http.service';
import { catchError, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppPermissionService } from '@core/services/app-permission.service';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import { BotStatusDataService } from '../service/bot-status-data.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
@Component({
  selector: 'kt-reconciliation-job-create',
  templateUrl: './reconciliation-job-create.component.html',
  styleUrls: ['./reconciliation-job-create.component.scss']
})
export class ReconciliationJobCreateComponent implements OnInit, OnDestroy {
    form: FormGroup;
    buttonLoading = false;
    ranges: any;
    messages$ = this.botStatusDataService.messages$;

    // permissions
    canCreateReconciliationJob: boolean;

    defaultStart = this.transactionHttpService.getYesterday().from;
    defaultEnd = this.transactionHttpService.getYesterday().to;

    merchantBankDropdownSettings = {};
    merchantBankDropdownList = [];
    filteredMerchantBankDropdownList = [];
    merchantBankSelectedItems = [];

    dropdown = {
        botReconciliationType: this.dropdownHttpService.botReconciliationType
    };
    private subscriptions: Subscription[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {},
        public dialogRef: MatDialogRef<ReconciliationJobCreateComponent>,
        private appPermissionService: AppPermissionService,
        private transactionHttpService: TransactionHttpService,
        private merchantBankHttpService: MerchantBankHttpService,
        private botStatusDataService: BotStatusDataService,
        private dropdownHttpService: DropdownHttpService,
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnInit() {
        this.merchantBankHttpService.getMerchantBanksAccount('&reconciliation=1').subscribe(res => {
            this.merchantBankDropdownList = res;
            this.filteredMerchantBankDropdownList = this.merchantBankDropdownList.filter(x => x.purpose == 1);
        });

        this.merchantBankDropdownSettings = {
        singleSelection: false,
        text: 'Please Select',
        maxHeight: 200,
        enableFilterSelectAll: false,
        enableSearchFilter: true,
        classes: 'dropdown',
        primaryKey: 'id',
        labelKey: 'merchant_bank_account',
        lazyLoading: false,
        noDataLabel: '',
        showCheckbox: false,
        autoPosition: false,
        disabled: false
        };

        this.ranges = this.transactionHttpService.ranges;
        this.formInit();

        const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
        this.canCreateReconciliationJob = appPermissions.create_reconciliation_job;
        });

        this.subscriptions.push(apSub);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

    onCloseDialog(value = false) {
        this.dialogRef.close(value);
    }

    onSave() {
        this.buttonLoading = true;
        // To set "Save" button to disable (To prevent call API in multiple times when double click)
        this.form.setErrors({ 'invalid': true });
        const data = {
        ...this.form.value
        }

        Object.keys(data).forEach((key) => key != 'defaultDate' && (data[key] == null || data[key] === '') && delete data[key]);
        
        this.botStatusDataService.createReconJob(data).pipe(
            tap((res: any) => {
                this.buttonLoading = false;
            }),
            catchError((error) => {
                this.buttonLoading = false;
                this.form.setErrors(null);
                throw error;
            })
        ).subscribe(); 
    }

    private formInit() {  
        this.form = new FormGroup({
            defaultDate: new FormControl({value: {startDate: this.defaultStart, endDate: this.defaultEnd}, disabled: true}),
            merchant_bank_id: new FormControl(null, [Validators.required]),
            bot_reconciliation_type_id: new FormControl(1, [Validators.required]),
        });  

        this.form.get('bot_reconciliation_type_id').valueChanges.subscribe((data) => {
            if (data != this.form.value.bot_reconciliation_type_id ) {
                this.merchantBankSelectedItems = [];
                this.form.patchValue({
                    merchant_bank_id: []
                })

                switch (data) {
                    case 1: // Deposit or Auto
                        this.filteredMerchantBankDropdownList = this.merchantBankDropdownList.filter(x => x.purpose == 1);
                        break;
                    case 2: // Withdrawal or Auto
                        this.filteredMerchantBankDropdownList = this.merchantBankDropdownList.filter(x => x.purpose == 2);
                        break;
                }

                this.cdr.detectChanges();
            }
        });
    }
}